// 1. Main sync function
function handleVariantImageSync(variantId) {
  console.log("=== handleVariantImageSync START ===");

  if (!variantId) { console.error("No variant ID"); return; }

  // Match variant by ID
  const variant = window.__sbProductData?.variants?.find(
    v => String(v.id) === String(variantId)
  );

  if (!variant) { console.error("No variant found for ID:", variantId); return; }
  console.log("Matched variant:", variant.title);

  // ✅ Get featured image src for this variant
  const featuredSrc = variant.featured_image?.src;
  if (!featuredSrc) { console.error("No featured_image src for variant:", variant.title); return; }

  // Normalize src for comparison (strip query string)
  const cleanSrc = featuredSrc.split('?')[0];
  console.log("Looking for slide with src:", cleanSrc);

  // Find matching swiper slide by src
  const slides = document.querySelectorAll('.sb-swiper-main .swiper-slide');
  if (slides.length === 0) { console.error("No swiper slides found"); return; }

  let targetIndex = null;
  slides.forEach((slide, index) => {
    const img = slide.querySelector('img');
    if (!img) return;

    const slideSrc = (img.src || img.dataset.src || '').split('?')[0];
    console.log(`slide[${index}] src:`, slideSrc);

    if (slideSrc.includes(cleanSrc) || cleanSrc.includes(slideSrc)) {
      targetIndex = index;
      console.log("✅ Swiper slide match at index:", targetIndex);
    }
  });

  if (targetIndex === null) { console.error("No swiper slide matched src:", cleanSrc); return; }

  const mainSwiper = document.querySelector('.sb-swiper-main')?.swiper;
  if (!mainSwiper) { console.error("Swiper instance not found"); return; }

  mainSwiper.slideTo(targetIndex, 300);
  console.log("=== Slid to index", targetIndex, "===");
}

// ✅ MutationObserver on hidden input — more reliable than setTimeout
const variantInput = document.querySelector('input.product-variant-id');
if (variantInput) {
  const observer = new MutationObserver(() => {
    const variantId = variantInput.value;
    console.log("Hidden input changed to:", variantId);
    handleVariantImageSync(variantId);
  });

  observer.observe(variantInput, { 
    attributes: true, 
    attributeFilter: ['value'] 
  });

  console.log("✅ Observer attached to input.product-variant-id");
} else {
  console.error("input.product-variant-id not found");
}

// 2. Attach listeners directly (no DOMContentLoaded needed in console)
const radioInputs = document.querySelectorAll('variant-selects input[type="radio"]');
console.log("Found variant radio inputs:", radioInputs.length);

radioInputs.forEach((input) => {
  input.addEventListener('change', function () {
    console.log("Radio changed:", this.value);
    setTimeout(() => {
      const variantId = document.querySelector('input.product-variant-id')?.value;
      console.log("Variant ID:", variantId);

      const variant = window.__sbProductData?.variants?.find(
        v => String(v.id) === String(variantId)
      );

      if (!variant) { console.error("No variant found for ID:", variantId); return; }
      console.log("Matched variant:", variant.title);
      handleVariantImageSync(JSON.stringify({ title: variant.title }));
    }, 100);
  });
});

console.log("✅ All listeners attached — now click a variant");